export default __webpack_public_path__ + "static/media/img_scsc_10.f1ea50d6.png";